export interface IEditEmergencyEventTbl {
	emergencyEventId: number;
	name?: string;
	location?: string;
	latitude?: string;
	longitude?: string;
	eventDate?: Date;
	isActive: boolean;
	strEventDate?: string;
	strIsActive?: string;
	isUpdatedOffline: boolean;
};

export class EditEmergencyEventTbl implements IEditEmergencyEventTbl {
	emergencyEventId = 0;
	name = '';
	location = '';
	latitude = '';
	longitude = '';
	eventDate = new Date();
	isActive = false;
	strEventDate = '';
	strIsActive = '';
	isUpdatedOffline = false;
};
